import { create } from 'superstruct';

import { URL_REPLACEMENT } from '$const';
import { get, post } from '~services/api/methods';
import {
  FetchNewsValidator,
  FetchPreferences,
  FetchPreferencesValidator,
  PostPreferencesValidator,
} from '~services/api/validators/Newsfeed';

export enum NewsfeedApiKeysEnum {
  FetchPreferences = 'fetchPreferences',
  PostPreferences = 'postPreferences',
  FetchNews = 'fetchNews',
}

export async function fetchNewsfeedNews() {
  const requestUrl = `${URL_REPLACEMENT.API_BASE}/../ebm/newsfeed/news`;
  let response;
  try {
    response = await get(requestUrl);
  } catch (_e) {
    response = [];
  }
  return create(response, FetchNewsValidator);
}

export async function fetchNewsfeedPreferences() {
  const requestUrl = `${URL_REPLACEMENT.API_BASE}/../ebm/newsfeed/preferences`;
  let response;
  try {
    response = await get(requestUrl);
  } catch (_e) {
    response = {};
  }
  return create(response, FetchPreferencesValidator);
}

export async function postNewsfeedPreferences(preferences: FetchPreferences) {
  const requestUrl = `${URL_REPLACEMENT.API_BASE}/../ebm/newsfeed/preferences`;
  const response = await post(requestUrl, preferences);
  return create(response, PostPreferencesValidator);
}
